export default [
    {
        path: "transactions",
        name: "treasury-transactions",
        redirect: { name: "treasury-transactions-list" },
        component: () => import("@/views/commons/transactions/Transactions.vue"),
        meta: {
            section: 39,
            breadcrumb: [
                {
                    text: "Transactions"
                },
            ],
            tabs: [
                {
                    title: "Transactions",
                    name: "treasury-transactions-list",
                },
            ],
        },
        children: [
            {
                path: "list",
                name: "treasury-transactions-list",
                component: () =>
                    import("@/views/commons/transactions/components/TransactionsTable.vue"),
                meta: {
                    section: 39,
                    tab: "pending",
                    pageTitle: "Transactions",
                    breadcrumb: [
                        {
                            text: "List",
                            active: true,
                        },
                    ],
                },
            },
        ],
    }
]